import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { type JSX, useState } from 'react';
import { DEFAULT_PUBLIC_ROUTE } from '@/config/constants';
import useSession from '@/hooks/use-session';
import useAuditorRouteGuard from './hooks/use-auditor-route-guard';
import usePermissionsByRoute from './hooks/use-permissions';
export type GateProps = {
  children: JSX.Element;
};
const Gate = t0 => {
  const $ = _c(16);
  const {
    children
  } = t0;
  const router = useRouter();
  const [shouldShowPage, setShowPage] = useState(false);
  const {
    logOut
  } = useSession();
  useAuditorRouteGuard();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowPage(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const next = t1;
  let t2;
  if ($[1] !== router) {
    t2 = (url, query) => {
      const handleRouteChangeComplete = () => {
        router.events.off("routeChangeComplete", handleRouteChangeComplete);
        next();
      };
      router.events.on("routeChangeComplete", handleRouteChangeComplete);
      router.push({
        pathname: url,
        query
      });
    };
    $[1] = router;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const redirect = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      next();
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== redirect) {
    t4 = {
      onSuccess: t3,
      onError: () => {
        redirect(DEFAULT_PUBLIC_ROUTE);
      }
    };
    $[4] = redirect;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      next();
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== logOut || $[8] !== redirect) {
    t6 = {
      onSuccess: t5,
      onError: t7 => {
        const {
          isLoggedIn,
          requiresOnboarding
        } = t7;
        if (!isLoggedIn) {
          logOut();
          const currentPath = `${window.location.pathname}${window.location.search}`;
          redirect("/authentication/sign-in", {
            redirectUrl: encodeURIComponent(currentPath)
          });
          return;
        }
        if (requiresOnboarding) {
          redirect("/onboarding");
          return;
        }
        redirect(DEFAULT_PUBLIC_ROUTE);
      }
    };
    $[7] = logOut;
    $[8] = redirect;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = {
      publicRoute: t4,
      privateRoute: t6
    };
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  usePermissionsByRoute(t7);
  let t8;
  if ($[13] !== children || $[14] !== shouldShowPage) {
    t8 = shouldShowPage ? children : <div />;
    $[13] = children;
    $[14] = shouldShowPage;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default Gate;